document.addEventListener("DOMContentLoaded", () => {
    if (!document.querySelector('.scroller.buehne')) return;

    const videoLoadBuffer = 1000;

    const scrollerContent = document.querySelectorAll('.scroller__content');
    const partnersucheLocations = document.querySelectorAll('.partnersuche__location');

    const $scroller = $('.scroller ul');

    const remainingVideoLength = (timer) => {
        const page = $scroller.data('page_visible')[0];
        const video = page.querySelector('.buehne-video');

        if (!video) return timer;

        return (video.duration - video.currentTime) * 1000;
    }

    window.setTimeout(() => {
        const timer = remainingVideoLength($scroller.data('pause') - videoLoadBuffer);
        clearTimeout($scroller.data('timer'))

        $scroller.data('timer', window.setTimeout(function () {
            const $right = $scroller.nextAll('.scroller_controls').find('button.scroller_right');
            $right.click();
        }, timer));
    }, videoLoadBuffer)

    scrollerContent.forEach((content) => {
        content.addEventListener('mouseenter', () => {
            clearTimeout($scroller.data('timer'));
        })

        content.addEventListener('mouseleave', () => {
            if (Array.from(partnersucheLocations).some(location => location === document.activeElement)) return;

            const timer = remainingVideoLength($scroller.data('pause'));

            $scroller.data('timer', window.setTimeout(function () {
                const $right = $scroller.nextAll('.scroller_controls').find('button.scroller_right');
                $right.click();
            }, timer));
        })
    });

    partnersucheLocations.forEach(location => {
        location.addEventListener('focus', () => {
            clearTimeout($scroller.data('timer'));
        })

        location.addEventListener('blur', () => {
            const timer = remainingVideoLength($scroller.data('pause'));

            $scroller.data('timer', window.setTimeout(function () {
                const $right = $scroller.nextAll('.scroller_controls').find('button.scroller_right');
                $right.click();
            }, timer));
        })
    })
});
